import { QueryFactory } from '@lmt/shared-types';
import { Loading } from '@lmt/unicorn-shared/app/components/common/Loading';
import { Button } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import { CheckBox } from '@lmt/unicorn-shared/app/components/common/ui-kit/CheckBox';
import globalStyles from '@lmt/unicorn-shared/app/components/global-forms/Content.module.scss';
import { FormComponentProps } from '@lmt/unicorn-shared/app/components/global-forms/GlobalForms.types';
import { getFormattedDateTimeRange } from '@lmt/unicorn-shared/app/components/patients/common';
import { useVisitTypes } from '@lmt/unicorn-shared/app/features/dictionaries/selectors';
import { useAdvancedForm } from '@lmt/unicorn-shared/app/helpers/form/advanced-form';
import { localizeVisitType } from '@lmt/unicorn-shared/app/helpers/localization/translations';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import clsx from 'clsx';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SelectVisitsPopup.module.scss';

type Form = {
  selectedVisits: any[];
};

type Props = FormComponentProps & {
  caseId: number;
  onVisitsSelected: (visits: number[]) => void;
};

export const SelectVisitsPopup: React.FC<Props> = React.memo(
  function SelectVisitsPopup(props) {
    const i18next = useScopedTranslation('documents.select_visits');
    const i18nextGlobal = useTranslation();
    const visitsQuery =
      QueryFactory.AppointmentEventsQuery.useSearchVisitsQuery({
        caseId: props.caseId,
      });
    const visitTypes = useVisitTypes();
    const form = useAdvancedForm<Form>(
      useCallback(async (data) => {
        props.onVisitsSelected(
          Array.isArray(data.selectedVisits)
            ? data.selectedVisits
            : [data.selectedVisits],
        );
        props.closeForm(props.formId);
      }, []),
    );

    return (
      <div
        className={globalStyles.autoSizedContainer}
        data-test-id="selectVisitsPopup"
      >
        <Loading loading={!visitsQuery.data}>
          <form
            onSubmit={form.handleSubmitDefault}
            className={globalStyles.form}
          >
            <div
              className={clsx(globalStyles.dataContainer, styles.dataContainer)}
            >
              {(visitsQuery.data ?? []).map((visit) => (
                <CheckBox
                  {...form.register('selectedVisits')}
                  value={visit.id}
                  key={visit.id}
                >
                  <span className={styles.visitTitle}>
                    {localizeVisitType(visitTypes, visit?.typeId)}
                  </span>
                  <span className={styles.visitDate}>
                    {getFormattedDateTimeRange(visit.start, visit.end)}
                  </span>
                </CheckBox>
              ))}
            </div>
            <div className={clsx(globalStyles.submitContainer)}>
              <Button
                className={globalStyles.submit}
                title={i18next.t('save_button')}
                type={'submit'}
              />
            </div>
          </form>
        </Loading>
      </div>
    );
  },
);
